<template>
  <router-view />
</template>

<script>
export default {
  name: 'Suppliers'
};
</script>

<style lang="scss" scoped></style>
